import React from "react";
import VideoSessionDetails from "./VideoSessionDetails";
import ServiceDetails from "../ServiceDetails/index";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import { CaretDown } from "@phosphor-icons/react";
import Participants from "./Participants";
import ViewAdhocSessionDetails from "./ViewAdhocSessionDetails";
import EditAdhocSessionDetails from "./EditAdhocSessionDetails";
import { useTheme } from "@mui/material/styles";

const SessionDetails = (props) => {
  const { classes, callDetailsRef, videoId, viewOnly } = props;
  const theme = useTheme();

  return (
    <Accordion
      defaultExpanded={true}
      sx={{
        width: "100%",
        "&.MuiPaper-root": {
          overflow: "visible",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<CaretDown color={theme.palette.action.active} />}
        sx={{
          minHeight: 2,
          padding: "0 !important",
          "&.Mui-expanded": {
            minHeight: 32,
          },
          "& .MuiAccordionSummary-content": {
            margin: "0 0 8px 0 !important",
          },
        }}
      >
        <Typography variant="h4" fontFamily={"TestTiemposText"}>
          Appointment Summary
        </Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          padding: "0 !important",
        }}
      >
        <div className={classes.sessionNoteDetails} ref={callDetailsRef}>
          {videoId ? (
            <div className={viewOnly ? classes.viewCallDetails : classes.callDetails}>
              <VideoSessionDetails {...props} />
              <Participants {...props} />
              <ServiceDetails {...props} />
            </div>
          ) : (
            <div className={classes.callDetails}>
              {viewOnly ? (
                <ViewAdhocSessionDetails {...props} />
              ) : (
                <EditAdhocSessionDetails {...props} />
              )}
            </div>
          )}
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default SessionDetails;
